import React from 'react';
import { useTheme } from '@mui/material';

export const PaidScreenOutIcon = () => {
    const theme = useTheme();
    const {
        stroke: { primary: primaryStroke },
    } = theme.colors.other.icon;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} fill="none">
            <path
                fill={primaryStroke}
                d="M17.581 12h3.457l-2 2h-1.094l-4.481 3.762-.282.238H13v-2.456l3.938-3.306.28-.238h.363Zm-5.687 18H11v4H4V16h7v12h1.719l.293.294 3.25 3.256.438.438.706.706 2.038 2.037 1.812-1.812.706-.706.707.706 1.662 1.662 2.232-2.225.706-.706.706.706.962.956 3.832-3.83-7.013-7-4.856 4.48-.744.688-.675-.75-4.262-4.731-.65-.732.712-.668 9.019-8.5.287-.269h6.107l.281.238L35 15.613V18h-.269l-.281-.238L29.969 14H25.38l-8.018 7.55 2.93 3.25 6.132-5.663.738-.68 1.356 1.468-.738.681-.55.506 6.8 6.813H37V16h7v18h-7v-4.075h-1.85l-.262.262-5.244 5.25-.706.707-.713-.706-.956-.957-2.225 2.225-.707.706-.706-.706-1.662-1.662-1.813 1.812-.706.706-.706-.706L16 34.106l-.706-.706-.438-.438L11.894 30ZM9 18H6v14h3V18Zm33 0h-3v14h3V18Z"
            />
        </svg>
    );
};
